import { ISO12100_LEVEL_COLORS } from '@/constants/iso12100.constants.js'

export default function Iso12100() {
  const getIso12100LevelColor = (level) => {
    return ISO12100_LEVEL_COLORS[level] || ''
  }

  return {
    getIso12100LevelColor,
  }
}
